import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-save",
  "use": "icon-save-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-save\"><defs><style type=\"text/css\"></style></defs><path d=\"M842.9 924.9H181.5V98.2h525.2l136.2 210.9v615.8z m-620.1-41.3h578.7V321.3L684.1 139.5H222.8v744.1z\" p-id=\"3084\" /><path d=\"M746.1 924.9H278.2V589h467.9v335.9z m-426.5-41.3h385.2V630.4H319.6v253.2zM519.6 140v122.8h-46.9V140H298.9v221H606V140z\" p-id=\"3085\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol